import { useContext, useState, useEffect } from "react"
import { CartContext } from "./CartContext"
import './css/QuantityBtn.css'

export default function QuantityBtn({productInfo, user }) {

    const {cartItems, setCartItems} = useContext(CartContext)

    let productIndexInCart = cartItems.findIndex((element)=>{
        return element.id === productInfo.id
    })

    let [numInCart,setNumInCart] = useState(
        (productIndexInCart===-1) ? 0 : cartItems[productIndexInCart].quantity
    )

    useEffect(() => {
        const savedCartItems = localStorage.getItem(`${user}_cartItems`);
        if (savedCartItems) {
          setCartItems(JSON.parse(savedCartItems));
        }
    }, [user, setCartItems]);

    const handleAdd = ()=>{

        let newCartItems;
        if(productIndexInCart===-1)
        {
            newCartItems = [{
                    id : productInfo.id,
                    商品名稱:productInfo.商品名稱,
                    img:productInfo.img,
                    售價:productInfo.售價,
                    產品特色:productInfo.產品特色,
                    quantity:1
                },
                ...cartItems]
            setCartItems(newCartItems)
        }
        else
        {
            let newCartArray = [...cartItems]
            newCartArray[productIndexInCart].quantity++
            newCartItems = newCartArray
            setCartItems(newCartItems)
        }
        localStorage.setItem(`${user}_cartItems`, JSON.stringify(newCartItems));
        setNumInCart(numInCart+1)
    }

    const handleSubtract = ()=>{

        let newCartItems;
        if(cartItems[productIndexInCart].quantity===1)
        {
            let newCartArray = [...cartItems]
            newCartArray.splice(productIndexInCart,1)
            newCartItems = newCartArray
            setCartItems(newCartItems)
        }
        else
        {
            let newCartArray = [...cartItems]
            newCartArray[productIndexInCart].quantity--
            newCartItems = newCartArray
            setCartItems(newCartItems)
        }
        localStorage.setItem(`${user}_cartItems`, JSON.stringify(newCartItems));
        setNumInCart(numInCart-1)
    }

    return (
        <div className="addToCart">
            {
                (numInCart === 0) ?
                <div>
                    <span className="addToCartBtn d-grid gap-2" onClick={handleAdd}>加入購物車</span>
                </div>
                 :
                // <div>
                //     <span className="subtractBtn" onClick={handleSubtract}>-</span>
                //     {numInCart}件
                //     <span className="addBtn" onClick={handleAdd}>+</span>
                // </div>
                <div class="input-group mb-3">
                <button className="subtractBtn" style={{ width: '50px' , fontWeight: 'bold',fontSize: '24px',backgroundColor: '#244e7e' }} type="button" onClick={handleSubtract}>-</button>
                <input type="text" class="form-control text-center" style={{ fontWeight: 'bold',fontSize: '24px' }} placeholder="" aria-label="Example text with two button addons" value={numInCart}件/>
                <button className="addBtn" style={{ width: '50px' , fontWeight: 'bold',fontSize: '24px' ,backgroundColor: '#244e7e'}} type="button" onClick={handleAdd}>+</button>
              </div>
            }
        </div>
    )
}